import React from "react";
import {Route, Switch} from "react-router-dom";
import BusinessCardRequestsFreightForwarder from "./BusinessCardRequestsFreightForwarder";
import SendBusinessCardRequest from "./SendBusinessCardRequest";


const App = ({match}) => (
  <Switch>
    <Route exact path={`${match.url}`} component={BusinessCardRequestsFreightForwarder}/>
    <Route path={`${match.url}/send-business-card`} component={SendBusinessCardRequest}/>
  </Switch>
);

export default App;
